import { useEffect, useState } from "react";
import { useFlowStore } from "../../store/FlowStateStore.ts";
import { CanvasNode, CanvasNodeData } from "../../models/CanvasNode.ts";
import LinkHandler from "./LinkHandler.tsx";

const SmartDelay: React.FC<any> = (data) => {
    const { nodes, setNodes } = useFlowStore();

    const savedData = (nodes
        .find((n) => n.data.id === data.nodeId)
        ?.data as CanvasNodeData)
        ?.content?.find((c) => c.id === data.subNodeId)?.data as any;

    const [delayValue, setDelayValue] = useState<number>(savedData?.delayValue ?? 1);
    const [delayUnit, setDelayUnit] = useState<string>(savedData?.delayUnit ?? "HOURS");

    const minDelayValue = delayUnit === "SECONDS" ? 30 : 1;

    const showWindowWarning =
        delayUnit === "DAYS" || (delayUnit === "HOURS" && delayValue >= 24);

    const isFloating = !nodes
        .flatMap((n) => (n as any).edges ?? [])
        .some((e: any) => e?.target === data.nodeId);

    useEffect(() => {
        const updatedNodes = nodes.map((node) => {
            if (node.data.id === data.nodeId) {
                return {
                    ...node,
                    data: {
                        ...node.data,
                        content: (node.data as CanvasNodeData).content.map((nodeContent) => {
                            if (nodeContent.id === data.subNodeId) {
                                return { ...nodeContent, data: { delayValue, delayUnit } };
                            }
                            return nodeContent;
                        }),
                    },
                };
            }
            return node;
        });
        setNodes([...(updatedNodes as CanvasNode[])]);
    }, [delayValue, delayUnit]);

    return (
        <div className="node-body">
            <div>
                <span className="font-label">Wait for</span>
                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                    <input
                        type="number"
                        min={minDelayValue}
                        value={delayValue}
                        onChange={(e) => setDelayValue(Math.max(minDelayValue, Number(e.target.value)))}
                        style={{ width: "70px" }}
                    />
                    <select
                        value={delayUnit}
                        onChange={(e) => {
                            const nextUnit = e.target.value;
                            setDelayUnit(nextUnit);
                            if (nextUnit === "SECONDS" && delayValue < 30) {
                                setDelayValue(30);
                            }
                        }}
                    >
                        <option value="SECONDS">Seconds</option>
                        <option value="MINUTES">Minutes</option>
                        <option value="HOURS">Hours</option>
                        <option value="DAYS">Days</option>
                    </select>
                </div>
            </div>

            {showWindowWarning && (
                <div style={{
                    marginTop: "8px",
                    padding: "6px 8px",
                    background: "#fff8e1",
                    border: "1px solid #f9a825",
                    borderRadius: "4px",
                    fontSize: "11px",
                    color: "#795548"
                }}>
                    ⚠️ After 24h, only <strong>Template</strong> nodes will work (Meta's messaging window closes).
                </div>
            )}

            <LinkHandler />
        </div>
    );
};

export default SmartDelay;
